<template>
  <div>
    <product-edit-dialog :p="selected" :state="EditDialog" @editDialog="editDialog"/>
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <Breadcrumbs
        headline="Quản lý khoản thu"
        :link="[{ text: 'Quản lý khoản thu', href: '../products' }]"
      />
      <product-list-actions />
    </div>
       <v-card class="pa-2 mx-md-2">
        <product-filter
          class="pa-4"
          @onFilterChanged="refresh"
        ></product-filter>
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="products"
          :search="search"
          class="mt-1"
          @click:row="onProductSelected"
          :loading="loading"
        >
          <template v-slot:item.price="{ item }">{{
            item.price | formatMoney
          }}</template>
          <template v-slot:item.status="{ item }">
            <v-chip label :color="getColor(item.status)" small dark>{{
              allProductStatus[item.status]
            }}</v-chip>
          </template>
          <template v-slot:item.action="{ item }">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small v-bind="attrs" v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="onClickRemoveMenu(item)">
                  <v-list-item-title>
                    <v-icon class="mr-3">delete</v-icon>
                    <span>Xóa</span>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="editDialog(item)">
                  <v-list-item-title >
                    <v-icon class="mr-3">mdi-border-color</v-icon>
                    <span>Sửa</span>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

    <v-dialog v-model="confirm.isOpen" max-width="548">
      <v-card>
        <v-toolbar color="#FFB300" dense class="elevation-0" dark>
          <v-toolbar-title>{{ confirm.title }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon dark @click="confirm.isOpen = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-5">
          <div v-html="confirm.htmlMessage" />
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer />
          <v-btn color="primary" @click="confirm.callback"> Xác nhận </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="#FFB300" dark>
        <v-card-text class="text-center pa-5">
          <div class="mb-5">Đang tải thời khóa biểu</div>
          <v-progress-circular
            indeterminate
            color="white"
          ></v-progress-circular>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import ProductFilter from '@/modules/product/ProductFilter'
import ProductListActions from '@/modules/product/ProductListActions.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import ProductEditDialog from '@/modules/product/ProductEditDialog.vue'

export default {
  components: {
    ProductFilter,
    ProductListActions,
    Breadcrumbs,
    ProductEditDialog
  },
  data() {
    return {
      confirm: {
        title: '',
        isOpen: false,
        currentItem: null,
        htmlMessage: '',
        callback: () => {},
      },
      search: '',
      expanded: [],
      loading: false,
      selected: null,
      headers: [
        {
          text: 'Mã',
          align: 'left',
          sortable: false,
          value: 'code',
        },
        { text: 'Khoản thu', value: 'title' },
        { text: 'Phân loại', align: 'right', value: 'type' },
        { text: 'Mức thu', align: 'right', value: 'price' },
        { text: '', value: 'action' },
      ],
      draw: false,
      productId: '',
      EditDialog: true,
    }
  },
  computed: {
    ...mapGetters('product', ['products', 'product']),
    ...mapGetters('constant', ['productStatus']),
    ...mapGetters('app', ['department']),
    allProductStatus() {
      return this.productStatus.reduce(
        (data, curent) => ({
          ...data,
          [curent.status]: curent['title'],
        }),
        {}
      )
    },
    productData() {
      return this.product(this.productId)
    },
    total() {
      return (
        this.products.reduce((total, product) => {
          return total + product.total
        }, 0) || 0
      )
    },
  },
  methods: {
    ...mapActions('product', [
      'fetchProducts',
      'setProduct',
      'removeProduct',
      'updateProduct',
    ]),
    onProductSelected(product) {
      this.expanded = []
      if (this.productId !== product.id) {
        this.expanded.push(product)
        this.productId = product.id
      } else {
        this.productId = ''
      }
    },
    updateDraw(state) {
      this.draw = state
    },
    async refresh(query) {
      this.loading = true
      await this.fetchProducts({ ...query })
      this.loading = false
    },
    getColor(status) {
      if (status === 'active') return 'green'
      else if (status === 'block') return 'red'
      else if (status === 'out-of-stock') return 'orange'
      else return 'gray'
    },
    onClickRemoveMenu(item) {
      this.confirm.isOpen = true
      this.confirm.title = 'Xác nhận xóa'
      this.confirm.htmlMessage = `Bạn có 
        <span class="text-uppercase font-weight-bold">chắc chắn</span> 
        xóa sản phẩm ?`
      this.confirm.callback = () => {
        const clonedItem = JSON.parse(JSON.stringify(item))
        this.removeProduct(clonedItem.id)
        this.confirm.isOpen = false
      }
    },
    editDialog(item) {
      this.selected = item
      this.EditDialog = !this.EditDialog
    },
    onClickChangeStatusMenu(item, status) {
      const clonedItem = JSON.parse(JSON.stringify(item))
      if (status === 'block') {
        this.confirm.isOpen = true
        this.confirm.title = 'Xác nhận xóa'
        this.confirm.htmlMessage = `Bạn có 
        <span class="text-uppercase font-weight-bold">chắc chắn</span> 
        muốn ngừng sản phẩm này?`
        this.confirm.callback = () => {
          this.updateProduct({
            ...clonedItem,
            status,
          })
          this.confirm.isOpen = false
        }
      } else {
        this.updateProduct({
          ...clonedItem,
          status,
        })
      }
    },
  },
  created: function () {
    if (this.products.length === 0) {
      this.refresh('')
    }
  },
  filters: {
    familiarizeDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format(' hh:mm Ngày DD/MM')
    },
    SimplizedDate: (time) => {
      if (!time) {
        return 'None'
      }
      return moment(time).format('DD/MM')
    },
    formatMoney(amount, decimalCount = 0, decimal = '.', thousands = ',') {
      try {
        decimalCount = Math.abs(decimalCount)
        decimalCount = isNaN(decimalCount) ? 0 : decimalCount

        const negativeSign = amount < 0 ? '-' : ''

        let i = parseInt(
          (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString()
        let j = i.length > 3 ? i.length % 3 : 0

        return (
          negativeSign +
          (j ? i.substr(0, j) + thousands : '') +
          i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) +
          (decimalCount
            ? decimal +
              Math.abs(amount - i)
                .toFixed(decimalCount)
                .slice(2)
            : '') +
          ' đ'
        )
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

To change the font size for a single component, such as a text field, application-wide:

<style lang="scss" scoped>
.content {
  margin: 0 !important;
  padding: 0 !important;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  background-color: white;
  width: 100%;
}
.image-wrapper {
  width: 124px;
  height: 124px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
::v-deep {
  .v-select__level-sale {
    font-size: 1em;
    border: none;
  }
}
</style>
